import { __awaiter } from '../../_virtual/_tslib.js';
import { AvailableCarriers } from '../domain/enums/available-carriers.js';
import { IuguTokenizer } from './iugu-tokenizer.js';
import { MultiTokenizer } from './multi-tokenizer.js';

class Tokenizer {
  /**
   * When the carrier is 'yuno', the tokenization is done by the Yuno Secure Fields itself, there's no need to create a Tokenizer.
   * See file `libs/frontend/modules/checkout/src/lib/presentation/hooks/use-yuno-secure-fields.tsx` for an example.
   */
  constructor(carrier) {
    if (carrier === AvailableCarriers.IUGU) {
      this.tokenizer = new IuguTokenizer();
    } else if (carrier === AvailableCarriers.MULTI) {
      this.tokenizer = new MultiTokenizer();
    } else {
      throw new Error('Invalid tokenizer type');
    }
  }
  tokenize(data) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.tokenizer.tokenize(data);
    });
  }
}

export { Tokenizer };
